<template>
  <div class="sel-popup">
    <div class="sel-popup__header">
      <div class="sel-popup__header-label" v-if="label">
        {{ label }}
      </div>
      <fai icon="times" 
        class="sel-popup__header-icon"
        @click="emitClose()"/>
    </div>
    <div class="sel-popup__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String
  },

  methods: {
    emitClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.sel-popup {
  background: white;
  padding: 2px 8px 8px 8px;
  border-radius: 8px;
  box-shadow: 0px 0px 13px 1px rgba(189,189,189,0.7);

  display: grid;
  grid-template-rows: min-content 1fr;

  &__header {
    display: grid;
    grid-template-columns: 1fr min-content;
    padding: 4px 0px;
    border-bottom: solid 1px $inactiveGrey;
    font-weight: bold;
    margin-bottom: 4px;
  }

  &__header-label {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__header-icon {
    grid-row-start: 1;
    grid-column-start: 2;
    grid-column-end: 3;
    padding: 4px;
    color: $inactiveGrey;
    font-size: 0.9em;
    cursor: pointer;
  }

  &__content {
    overflow-y: scroll;
  }
}
</style>
